import createSimplePrivateGallery from '@PROJECT_ROOT/assets/desktop/js/search/simplePrivateGallery';
import makeShowMapInfoWindow from '@PROJECT_ROOT/assets/mobile/js/shared/mapInfoWindow';

export default function makeShowFacilityDetails(searchResultsMap, facilityDetailsUrl, searchParameters, google) {
    const showMapInfoWindow = makeShowMapInfoWindow(google, searchResultsMap);
    let fetchFacilityContent = null;

    return function showFacilityDetails({ marker, facilityId }) {
        if (fetchFacilityContent !== null) {
            fetchFacilityContent.abort();
        }

        const htmlContentPromise = new Promise((resolve, reject) => {
            fetchFacilityContent = $.post(facilityDetailsUrl.replace('id', facilityId), searchParameters);
            fetchFacilityContent.then(({ state, facilityContent }) => {
                const contentContainer = document.createElement('div');
                contentContainer.innerHTML = facilityContent;
                setUpFacilityInfoGallery(state.facilityGallery, contentContainer);

                resolve(contentContainer);
            }, (error) => {
                reject(error);
            });
        });

        showMapInfoWindow(htmlContentPromise, marker);
    };

    function setUpFacilityInfoGallery(facilityGallery, contentContainer) {
        const galleryContainer = contentContainer.querySelector('.js-facilityGallery');

        if (galleryContainer === null) {
            return;
        }

        createSimplePrivateGallery({
            source: facilityGallery,
            previousButton: galleryContainer.querySelector('.js-galleryPrevButton'),
            nextButton: galleryContainer.querySelector('.js-galleryNextButton'),
            counterElement: galleryContainer.querySelector('.js-galleryCounter'),
            imageElement: galleryContainer.querySelector('.js-currentImage img'),
        });
    }
}
